import { FunctionComponent } from 'react'
import styled from 'styled-components'

const StyledTextWrapper = styled.div`
  min-width: 0;
  width: 100%;
  box-sizing: border-box;

  padding: 6px 6px 6px 10px;
`

type TextWrapperProps = {
  children?: React.ReactNode
}

const TextWrapper: FunctionComponent<TextWrapperProps> = ({ children }) => {
  return <StyledTextWrapper>{children}</StyledTextWrapper>
}

export default TextWrapper
